/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeliverFeeWarehouseStepRespVo } from './DeliverFeeWarehouseStepRespVo';
import {
    DeliverFeeWarehouseStepRespVoFromJSON,
    DeliverFeeWarehouseStepRespVoFromJSONTyped,
    DeliverFeeWarehouseStepRespVoToJSON,
    DeliverFeeWarehouseStepRespVoToJSONTyped,
} from './DeliverFeeWarehouseStepRespVo';

/**
 * 
 * @export
 * @interface GradeFeeRespVo1
 */
export interface GradeFeeRespVo1 {
    /**
     * 会员等级ID
     * @type {number}
     * @memberof GradeFeeRespVo1
     */
    gradeId?: number;
    /**
     * 明细渲染模式：STEP 步长规则
     * @type {string}
     * @memberof GradeFeeRespVo1
     */
    ruleMode?: string;
    /**
     * 
     * @type {DeliverFeeWarehouseStepRespVo}
     * @memberof GradeFeeRespVo1
     */
    stepRule?: DeliverFeeWarehouseStepRespVo;
}

/**
 * Check if a given object implements the GradeFeeRespVo1 interface.
 */
export function instanceOfGradeFeeRespVo1(value: object): value is GradeFeeRespVo1 {
    return true;
}

export function GradeFeeRespVo1FromJSON(json: any): GradeFeeRespVo1 {
    return GradeFeeRespVo1FromJSONTyped(json, false);
}

export function GradeFeeRespVo1FromJSONTyped(json: any, ignoreDiscriminator: boolean): GradeFeeRespVo1 {
    if (json == null) {
        return json;
    }
    return {
        
        'gradeId': json['gradeId'] == null ? undefined : json['gradeId'],
        'ruleMode': json['ruleMode'] == null ? undefined : json['ruleMode'],
        'stepRule': json['stepRule'] == null ? undefined : DeliverFeeWarehouseStepRespVoFromJSON(json['stepRule']),
    };
}

export function GradeFeeRespVo1ToJSON(json: any): GradeFeeRespVo1 {
    return GradeFeeRespVo1ToJSONTyped(json, false);
}

export function GradeFeeRespVo1ToJSONTyped(value?: GradeFeeRespVo1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gradeId': value['gradeId'],
        'ruleMode': value['ruleMode'],
        'stepRule': DeliverFeeWarehouseStepRespVoToJSON(value['stepRule']),
    };
}

